import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { CitationView } from './CitationView';

export const CitationNode = Node.create({
  name: 'citation',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      citation_ref: {
        default: '',
        parseHTML: (element: HTMLElement) => element.getAttribute('data-citation-ref'),
        renderHTML: (attributes: Record<string, unknown>) => ({
          'data-citation-ref': attributes.citation_ref,
        }),
      },
      source_title: {
        default: '',
        parseHTML: (element: HTMLElement) => element.getAttribute('data-source-title'),
        renderHTML: (attributes: Record<string, unknown>) => ({
          'data-source-title': attributes.source_title,
        }),
      },
      source_snippet: {
        default: '',
        parseHTML: (element: HTMLElement) => element.getAttribute('data-source-snippet'),
        renderHTML: (attributes: Record<string, unknown>) => ({
          'data-source-snippet': attributes.source_snippet,
        }),
      },
      citation_number: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const value = element.getAttribute('data-citation-number');
          return value ? Number(value) : null;
        },
        renderHTML: (attributes: Record<string, unknown>) => ({
          'data-citation-number': attributes.citation_number,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-type="citation"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes({ 'data-type': 'citation' }, HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CitationView);
  },
});
